import { Component, Input, OnChanges, SimpleChanges, Output, EventEmitter } from '@angular/core';

import { Dirette, Giocatori, TIPI_EVENTO, Squadre } from '../shared/shared.module';

@Component({
    moduleId: module.id,
    selector: 'formazioni',
    templateUrl: 'formazioni.html'
})
export class FormazioniComponent implements OnChanges {

    @Input() diretta: Dirette = null;
    @Input() direttaPortale: boolean = false;

    @Output() firstPlayerChoosed = new EventEmitter();
    @Output() playersChoosed = new EventEmitter();
    @Output() backToEventPicker = new EventEmitter();

    team1_titolari: Array<Giocatori> = new Array<Giocatori>();
    team1_riserve: Array<Giocatori> = new Array<Giocatori>();
    team2_titolari: Array<Giocatori> = new Array<Giocatori>();
    team2_riserve: Array<Giocatori> = new Array<Giocatori>();
    idEvento: number = null;
    showContinue = false;
    public player_1: Giocatori = null;
    public player_2: Giocatori = null;
    public team_1: Squadre = null;
    public team_2: Squadre = null;
    istruzioni: string = "";
    preCognomi: string[] = [
        "da",
        "dal",
        "dall'",
        "dalla",
        "dalle",
        "dalli",
        "dallo",
        "dagli",
        "de",
        "del",
        "dell'",
        "della",
        "delle",
        "delli",
        "dello",
        "degli",
        "di",
        "lo",
        "la",
        "le",
        "li",
        "van",
        "von",
        "wan",
        "won"
    ];

    ngOnChanges(changes: SimpleChanges): void {
        if (changes["diretta"]) {
            if (this.diretta.match.team1.formazione) {
                this.team1_titolari = this.diretta.match.team1.formazione.filter(x => x.titolare);
                this.team1_riserve = this.diretta.match.team1.formazione.filter(x => !x.titolare);
            }
            if (this.diretta.match.team2.formazione) {
                this.team2_titolari = this.diretta.match.team2.formazione.filter(x => x.titolare);
                this.team2_riserve = this.diretta.match.team2.formazione.filter(x => !x.titolare);
            }

            setTimeout(() => {
                let h1 = document.querySelector(".team.home");
                let g1 = document.querySelector(".team.guest");
                let h2 = document.querySelector(".team.home.riserve");
                let g2 = document.querySelector(".team.guest.riserve");

                let a1 = Math.max(h1.getBoundingClientRect().height, g1.getBoundingClientRect().height);
                (h1 as any).style.height = a1.toString() + 'px';
                (g1 as any).style.height = a1.toString() + 'px';

                let a2 = Math.max(h2.getBoundingClientRect().height, g2.getBoundingClientRect().height);
                (h2 as any).style.height = a2.toString() + 'px';
                (g2 as any).style.height = a2.toString() + 'px';
            }, 0);
        }
    }

    resetChoice(idEvento: number) {
        this.player_1 = null;
        this.player_2 = null;
        this.team_1 = null;
        this.team_2 = null;
        this.showContinue = false;
        this.idEvento = idEvento;
        this.setIstruzioni();
    }

    selectable_team(): boolean {
        if (this.direttaPortale) return false;
        switch (this.idEvento) {
            case TIPI_EVENTO.Corner:
            case TIPI_EVENTO.Punizione:
            case TIPI_EVENTO.Rigore:
                return true;
            default:
                return false;
        }
    }

    selectable(giocatore: Giocatori): boolean {
        if (this.direttaPortale) return false;
        if (this.player_1 == null) {
            switch (this.idEvento) {
                case TIPI_EVENTO.Ammonizione:
                case TIPI_EVENTO.Autogol:
                case TIPI_EVENTO.Espulsione:
                case TIPI_EVENTO.Fallo:
                case TIPI_EVENTO.Gol:
                case TIPI_EVENTO.Cambio:
                case TIPI_EVENTO.Palo:
                case TIPI_EVENTO.Tiro_fuori:
                case TIPI_EVENTO.Tiro_parato:
                case TIPI_EVENTO.Tiro_respinto:
                case TIPI_EVENTO.Traversa:
                case TIPI_EVENTO.Rigore_fallito:
                    return this.canPlay(giocatore);
                case TIPI_EVENTO.Corner:
                case TIPI_EVENTO.Punizione:
                case TIPI_EVENTO.Rigore:
                default:
                    return false;
            }
        }
        else {
            switch (this.idEvento) {
                case TIPI_EVENTO.Cambio:
                    return this.canEnter(giocatore, this.player_1.id);
                case TIPI_EVENTO.Gol:
                    return this.canAssist(giocatore, this.player_1.id);
                case TIPI_EVENTO.Ammonizione:
                case TIPI_EVENTO.Autogol:
                case TIPI_EVENTO.Corner:
                case TIPI_EVENTO.Espulsione:
                case TIPI_EVENTO.Fallo:
                case TIPI_EVENTO.Palo:
                case TIPI_EVENTO.Punizione:
                case TIPI_EVENTO.Rigore:
                case TIPI_EVENTO.Tiro_fuori:
                case TIPI_EVENTO.Tiro_parato:
                case TIPI_EVENTO.Tiro_respinto:
                case TIPI_EVENTO.Traversa:
                case TIPI_EVENTO.Rigore_fallito:
                default:
                    return false;
            }
        }
    }

    chooseTeam(team: Squadre) {
        if (this.direttaPortale) return;
        this.team_1 = team;
        this.choiceComplete();
    }

    choosePlayer(giocatore: Giocatori) {
        if (this.direttaPortale) return;
        if (this.player_1 == null) {
            this.player_1 = this.findPlayer(giocatore.id);
            this.team_1 = this.findPlayerTeam(this.player_1.id);
            this.setIstruzioni();
            switch (this.idEvento) {
                case TIPI_EVENTO.Ammonizione:
                case TIPI_EVENTO.Autogol:
                case TIPI_EVENTO.Espulsione:
                case TIPI_EVENTO.Fallo:
                case TIPI_EVENTO.Palo:
                case TIPI_EVENTO.Tiro_fuori:
                case TIPI_EVENTO.Tiro_parato:
                case TIPI_EVENTO.Tiro_respinto:
                case TIPI_EVENTO.Traversa:
                case TIPI_EVENTO.Rigore_fallito:
                    this.choiceComplete();
                    break;
                case TIPI_EVENTO.Gol:
                    this.showContinue = true;
                    this.firstPlayerChoosed.emit();
                    break;
                case TIPI_EVENTO.Cambio:
                    this.firstPlayerChoosed.emit();
                    break;
                default:
                    break;
            }
        }
        else {
            this.player_2 = this.findPlayer(giocatore.id);
            this.team_2 = this.findPlayerTeam(this.player_2.id);
            this.choiceComplete();
        }
    }

    setIstruzioni() {
        if (this.direttaPortale) {
            this.istruzioni = "Formazioni";
        }
        if (this.player_1 == null) {
            switch (this.idEvento) {
                case TIPI_EVENTO.Ammonizione:
                    this.istruzioni = "Seleziona il giocatore ammonito";
                    break;
                case TIPI_EVENTO.Autogol:
                    this.istruzioni = "Seleziona l'autore dell'autogol";
                    break;
                case TIPI_EVENTO.Espulsione:
                    this.istruzioni = "Seleziona il giocatore espulso";
                    break;
                case TIPI_EVENTO.Fallo:
                    this.istruzioni = "Seleziona l'autore del fallo";
                    break;
                case TIPI_EVENTO.Palo:
                case TIPI_EVENTO.Tiro_fuori:
                case TIPI_EVENTO.Tiro_parato:
                case TIPI_EVENTO.Tiro_respinto:
                case TIPI_EVENTO.Traversa:
                    this.istruzioni = "Seleziona l'autore dell'azione";
                    break;
                case TIPI_EVENTO.Gol:
                    this.istruzioni = "Seleziona l'autore del gol";
                    break;
                case TIPI_EVENTO.Rigore_fallito:
                    this.istruzioni = "Seleziona il giocatore che ha fallito il rigore";
                    break;
                case TIPI_EVENTO.Cambio:
                    this.istruzioni = "Seleziona il giocatore che esce";
                    break;
                case TIPI_EVENTO.Corner:
                    this.istruzioni = "Seleziona la squadra che batterà il corner";
                    break;
                case TIPI_EVENTO.Punizione:
                    this.istruzioni = "Seleziona la squadra che batterà la punizione";
                    break;
                case TIPI_EVENTO.Rigore:
                    this.istruzioni = "Seleziona la squadra che batterà il rigore";
                    break;
                default:
                    break;
            }
        }
        else {
            switch (this.idEvento) {
                case TIPI_EVENTO.Cambio:
                    this.istruzioni = "Seleziona il giocatore che entra";
                    break;
                case TIPI_EVENTO.Gol:
                    this.istruzioni = "Seleziona l'autore dell'assist o prosegui";
                    break;
                default:
                    return false;
            }
        }
    }

    findPlayer(idGiocatore: number): Giocatori {
        let result: Giocatori = this.diretta.match.team1.formazione.find(x => x.id == idGiocatore);
        if (!result) result = this.diretta.match.team2.formazione.find(x => x.id == idGiocatore);
        return result;
    }

    findPlayerTeam(idGiocatore: number): Squadre {
        let team: Squadre = null;
        if (this.diretta.match.team1.formazione.find(x => x.id == idGiocatore)) team = this.diretta.match.team1;
        if (this.diretta.match.team2.formazione.find(x => x.id == idGiocatore)) team = this.diretta.match.team2;
        return team;
    }

    canPlay(giocatore: Giocatori): boolean {
        if (giocatore.redcards > 0) return false;
        if (giocatore.titolare) return !(giocatore.sub > 0);
        else return (giocatore.sub == 1);
    }

    canEnter(giocatore: Giocatori, exitingPlayerId: number): boolean {
        let idTeam: number = this.findPlayerTeam(exitingPlayerId).id;
        let riserveSquadra: Giocatori[] = idTeam == this.diretta.match.team1.id ? this.team1_riserve : this.team2_riserve;
        let riserva: Giocatori = riserveSquadra.find(x => x.id == giocatore.id);
        if (riserva) return !(riserva.sub > 0) && !(riserva.redcards > 0);
        else return false;
    }

    canAssist(giocatore: Giocatori, scorerId: number): boolean {
        return this.canPlay(giocatore)
            && (this.findPlayerTeam(scorerId).id == this.findPlayerTeam(giocatore.id).id)
            && giocatore.id != scorerId;
    }

    choiceComplete() {
        if (this.direttaPortale) return;
        this.playersChoosed.emit();
    }

    back() {
        if (this.direttaPortale) return;
        this.backToEventPicker.emit();
    }

    goalsArray(quantita: number): Array<any> {
        if (quantita && quantita > 0) return Array(quantita).fill(1);
        else return [];
    }

    getNome(nome: string): string {
        return this.separaNomi(nome).nome;
    }

    getCognome(nome: string): string {
        return this.separaNomi(nome).cognome;
    }

    separaNomi(nome: string): any {
        let result = {
            nome: null,
            cognome: null
        };

        if (nome) {
            nome = nome.trim();
            let parole: string[] = nome.split(" ");
            if (parole.length == 1) {
                result.cognome = parole[0];
                result.nome = null;
            } else if (parole.length == 2) {
                result.cognome = parole[1];
                result.nome = parole[0];
            } else {
                let found: boolean = false;
                this.preCognomi.forEach(p => {
                    let s = ' ' + p + ' ';
                    let pos = nome.toLowerCase().indexOf(s);
                    if (pos > -1) {
                        found = true;
                        result.cognome = nome.substr(pos, nome.length - pos).trim();
                        result.nome = nome.substr(0, pos).trim();
                    }
                });
                if(!found) {
                    result.cognome = parole[parole.length - 1];
                    result.nome = nome.replace(parole[parole.length - 1], "").trim();
                }
            }
        }

        return result;
    }

    getAbbreviazione(nomeSquadra: string): string {
        let result: string = nomeSquadra;
        if (result && result.length > 15 && result.indexOf(" ") > -1) {
            let words: string[] = result.split(" ");
            words[words.length - 1] = words[words.length - 1].substr(0, 1) + ".";
            result = words.join(" ");
        }
        return result;
    }
}


// WEBPACK FOOTER //
// ./src/app/formazioni/formazioni.component.ts